import React from 'react'
import Button from "react-bootstrap/es/Button";
import {Row, Col} from "react-bootstrap";

class CompanyConfigurationGrid {
  translate = {
    CAN_DO_TRANSACTION_SAME_LSD: 'PODE FAZER TRANSAÇÃO MESMO LSD',
    CAN_SHOW_WEIGHT: 'PODE MOSTRAR PESO',
    MOVEMENT_ORDER_URL: 'URL DE ORDEM DE MOVIMENTO',
    KEY_TEGMA: 'CHAVE DE AUTENTICAÇÃO DA API DA TEGMA',
    INVENTORY_CHECKPOINT_NOT_FOUND: 'CHECKPOINT DE ITENS DO INVENTÁRIO NÃO ENCONTRADO',
    INVENTORY_CHECKPOINT_UNEXPECTED: 'CHECKPOINT DE ITENS DO INVENTÁRIO INESPERADOS',
    MIN_TIME_IN_SECONDS_BETWEEN_TRANSACTION_SAME_LSD: 'PODE FAZER TRANSAÇÃO MESMO LSD APOS UM TEMPO DETERMINADO EM SEGUNDOS',
  }

  traducao(row) {
    return this.translate(row.key)
  }

  title = "Configurações da Empresa"
  showNewButton = false
  columns = [
    {
      Header: 'Tipo',
      accessor: 'key',
      HeaderColumn: true,
      Cell: row => (
        <div>
          {this.translate[row.original.key]}
        </div>
      )
    },
    {
      Header: 'Valor',
      acessor: 'value',
      Cell: row => (
        row.original.value
      )
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
        <Row className="justify-content-around">
          <Col sm={6}>
            <Button bsStyle="success" href={`#/company-configurations/${row.original.id}/edit`} block>Editar</Button>
          </Col>
        </Row>
      )
    }
  ]
  endpoint = () => {
    return `ton/v1/company-configurations/`;
  };
}

export default CompanyConfigurationGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/CompanyConfigurationGrid.js